<template>
  <div>
    <label class="small text-muted">{{ label }}</label>
    <b-form-select :options="options" v-model="internalValue" class="ml-1" :disabled="options.length <= 1"/>
  </div>
</template>

<script>
import service from '../../services/llm-comparison'

export default {
  name: 'LLMSelect',
  props: { value: { required: false }, models: { type: Array, default: () => [] }, label: { type: String, default: 'Model' } },
  data() {
    return {
      internalModels: []
    }
  },
  computed: {
    effectiveModels() {
      return (this.models && this.models.length) ? this.models : this.internalModels
    },
    options() {
      const opts = (this.effectiveModels || []).map(m => {
        if (typeof m === 'string') return { value: m, text: m }
        const name = m && m.name ? m.name : ''
        return { value: name, text: (m.displayName || name), disabled: !name }
      }).filter(o => o)
      return [{ value: null, text: 'Select Model' }, ...opts]
    },
    internalValue: {
      get() { return this.value },
      set(v) { this.$emit('input', v) }
    }
  },
  async created() {
    // Removed: models are now passed from parent component
  }
}

</script>
